const EmailTemplateCatelogType = {
  RELEASE_TO_CUSTOMER: 1,
  CONFIRM_USED_VOUCHER_FROM_CUSTOMER: 2,
  USED_VOUCHER: 3,
  CUSTOMER_CONFIRM_REGISTER_ACCOUNT: 4
}

export default EmailTemplateCatelogType
